import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius, shadow } from '~styles/theme.stylex';
const REDUCED = '@media (prefers-reduced-motion: reduce)';

// One 12s timeline shared by every element (same duration, no delays) so the
// loop never drifts: Maya types (2–14%), then each reply lands as its joiner
// pops onto the card — Dev 20%, Lena 36%, Sam 52%, Theo joins silently at 68%
// — while the capacity bar steps 1/7 → 5/7. Hold, fade, restart.
// Base styles are the resting state — reduced-motion users see the final frame.

const askIn = "x1umedf3-B";
const dotsPhase = "x3rzmfl-B";
const textPhase = "xwb5vjg-B";
const replyIn1 = "x4snsv4-B";
const replyIn2 = "xznkblh-B";
const replyIn3 = "x13t4wd4-B";
const pop1 = "xtqwlka-B";
const pop2 = "x1xxo28x-B";
const pop3 = "x13u1vge-B";
const pop4 = "x1f2e2wl-B";
const grow = "x5vmbv1-B";
const pulse = "x1cn5uyj-B";

// One-shot entrances for the visitor's own join (button click, not the loop).
const popIn = "x13gcgf9-B";
const slideIn = "x3xj9ga-B";
export const styles = {
  scene: {
    position: "x1n2onr6",
    width: "xh8yej3",
    height: "x8wrrh",
    borderRadius: "x1j6x5gx",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    backgroundColor: "x1mmbalx",
    boxShadow: "x13g88js",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    justifyContent: "x1qughib",
    gap: "x15iy025",
    rowGap: null,
    columnGap: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  map: {
    position: "x10l6tqk",
    inset: "x10a8y8t",
    insetInline: null,
    insetInlineStart: null,
    insetInlineEnd: null,
    left: null,
    right: null,
    insetBlock: null,
    top: null,
    bottom: null,
    width: "xh8yej3",
    height: "x5yr21d",
    $$css: true
  },
  radius: {
    position: "x10l6tqk",
    top: "x2kg9na",
    left: "xtzohx4",
    insetInlineStart: null,
    insetInlineEnd: null,
    width: "x1f9tj09",
    aspectRatio: "x1plog1",
    transform: "x11lhmoz",
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x1col5h6",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "xh12s4h",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  pin: {
    position: "x10l6tqk",
    top: "xzc2ltc",
    left: "x1t3n655",
    insetInlineStart: null,
    insetInlineEnd: null,
    $$css: true
  },
  pinDot: {
    position: "x10l6tqk",
    width: "x1xvt488",
    height: "xf08kfj",
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x1ehzqq1",
    borderWidth: "xdh2fpr",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1w1xcey",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  pinPulse: {
    position: "x10l6tqk",
    width: "x1xvt488",
    height: "xf08kfj",
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x1ehzqq1",
    animationName: "x1s4jii9 x1aquc0h",
    animationDuration: "xius3t",
    animationTimingFunction: "xa3vuyk",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  card: {
    position: "x1n2onr6",
    alignSelf: "xqcrz7y",
    marginLeft: "x6ge7cq",
    marginInlineStart: null,
    marginInlineEnd: null,
    width: "xktia5q",
    backgroundColor: "x1xaky2g",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x8hbxov",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    boxShadow: "xswbnm3",
    transform: "x1d74iyf",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  cardAvatars: {
    display: "x78zum5",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  popOnce: {
    animationName: "x1h2ing3 x1aquc0h",
    animationDuration: "xfbpl4g",
    animationTimingFunction: "x1debuo4",
    $$css: true
  },
  slideOnce: {
    animationName: "x1gla395 x1aquc0h",
    animationDuration: "xfbpl4g",
    animationTimingFunction: "x1debuo4",
    $$css: true
  },
  join1: {
    animationName: "x1azdvel x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  join2: {
    animationName: "xj0o0nb x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  join3: {
    animationName: "x16sbg7o x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  join4: {
    animationName: "x17bctx6 x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  cardTitle: {
    fontSize: "x1jchvi3",
    fontWeight: "x1sl8krj",
    color: "xtt1gjl",
    $$css: true
  },
  cardPills: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    alignItems: "x6s0dn4",
    $$css: true
  },
  pill: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "xd7ozn7",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    fontSize: "xboafo0",
    fontWeight: "xlr2uoh",
    lineHeight: "xo5v014",
    color: "xtt1gjl",
    $$css: true
  },
  pillBlue: {
    backgroundColor: "x1psf1j9",
    color: "x1bj2zf7",
    $$css: true
  },
  pillCyan: {
    backgroundColor: "x19tgrng",
    color: "x18yk8ih",
    $$css: true
  },
  pillGray: {
    backgroundColor: "x1gvq2gg",
    color: "xarw3lm",
    $$css: true
  },
  pillPeach: {
    backgroundColor: "x15xno7f",
    paddingInline: "xvpgqt4",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  capacity: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  capacityIcon: {
    color: "x1gonuu0",
    flexShrink: "x2lah0s",
    $$css: true
  },
  track: {
    flex: "x98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    height: "x164u9eo",
    borderRadius: "x6i6fhv",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x4aap8p",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    display: "x1lliihq",
    $$css: true
  },
  fill: {
    display: "x1lliihq",
    height: "x5yr21d",
    width: "x13kl4bn",
    borderRadius: "x6i6fhv",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xwk94rn",
    animationName: "xaz0rkl x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1esw782",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  fillJoined: {
    width: "xfx8rd5",
    animationName: "x1a5igra",
    transitionProperty: "xxrbq2n",
    transitionDuration: "xofcydl",
    $$css: true
  },
  cardWhen: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    backgroundColor: "x80m72e",
    borderRadius: "xmx9ex2",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xvpgqt4",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "x1dcheo9",
    fontWeight: "xr323w7",
    color: "xtt1gjl",
    $$css: true
  },
  whenIcon: {
    color: "x1n9cmz0",
    flexShrink: "x2lah0s",
    $$css: true
  },
  joinButton: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    width: "xh8yej3",
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderRadius: "xmx9ex2",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    font: "xln7xf2",
    fontFamily: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontVariantAlternates: null,
    fontVariantCaps: null,
    fontVariantEastAsian: null,
    fontVariantEmoji: null,
    fontVariantLigatures: null,
    fontVariantNumeric: null,
    fontVariantPosition: null,
    lineHeight: null,
    fontSize: "xkpwil5",
    fontWeight: "xlr2uoh",
    cursor: "x1ypdohk",
    $$css: true
  },
  joinedRow: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "x1qughib",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    flexWrap: "x1a02dak",
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    $$css: true
  },
  joinedText: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    color: "x1617y9h",
    $$css: true
  },
  joinedLink: {
    color: "x1gonuu0",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    $$css: true
  },
  chat: {
    position: "x1n2onr6",
    width: "xh8yej3",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  msg: {
    display: "x78zum5",
    alignItems: "xuk3077",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    maxWidth: "x17na0u1",
    $$css: true
  },
  msgLeft: {
    alignSelf: "xqcrz7y",
    $$css: true
  },
  msgRight: {
    alignSelf: "xpvyfi4",
    $$css: true
  },
  ask: {
    animationName: "xscxbjk x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  reply1: {
    animationName: "x104hpnh x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  reply2: {
    animationName: "x1yql8g4 x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  reply3: {
    animationName: "x5ack8n x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  bubble: {
    position: "x1n2onr6",
    backgroundColor: "x1xaky2g",
    borderRadius: "x15fclwp",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderEndStartRadius: "xt6ftvx",
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xvpgqt4",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    boxShadow: "x1hxhvl9",
    fontSize: "x1dcheo9",
    lineHeight: "x37zpob",
    color: "xtt1gjl",
    $$css: true
  },
  bubbleRight: {
    borderEndStartRadius: "x1x0ge52",
    borderEndEndRadius: "x1bqiyuo",
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "x15xno7f",
    $$css: true
  },
  bubbleYou: {
    borderEndStartRadius: "x1x0ge52",
    borderEndEndRadius: "x1bqiyuo",
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    $$css: true
  },
  bubbleAsk: {
    fontSize: "xkpwil5",
    $$css: true
  },
  bubbleName: {
    display: "x1lliihq",
    fontSize: "x12lo8hy",
    fontWeight: "xlr2uoh",
    color: "xarw3lm",
    marginBottom: "xhcrhct",
    $$css: true
  },
  bubbleDots: {
    position: "x10l6tqk",
    display: "x3nfvp2 xkio4u3",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    alignItems: "x6s0dn4",
    height: "xaylbqo",
    opacity: "xg01cxk",
    animationName: "xw9g80l x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  },
  dot: {
    width: "xrkia0p",
    height: "x4j2xbe",
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xy6l9b",
    $$css: true
  },
  dotB: {
    opacity: "x1ks1olk",
    $$css: true
  },
  dotC: {
    opacity: "xti2d7y",
    $$css: true
  },
  bubbleText: {
    opacity: "x1hc1fzr",
    animationName: "x1fz91kg x1aquc0h",
    animationDuration: "x17rb3hg",
    animationTimingFunction: "x1debuo4",
    animationIterationCount: "xa4qsjk",
    $$css: true
  }
};